module.exports = __webpack_public_path__ + "img/demand.ecdb037c.svg";